var render = function render(){var _vm=this,_c=_vm._self._c;return _c('slice',{key:"slice-gallery",staticClass:"slice--gallery",class:{
    container: _vm.block.with_container,
    'with-gap': _vm.block.with_gap,
  },attrs:{"id":_vm.block._key}},_vm._l((_vm.matrix),function(item,index){return _c('div',{directives:[{name:"waypoint",rawName:"v-waypoint",value:({
      active: !_vm.imagesSeen.includes(index),
      callback: (w) => _vm.onImageWaypoint(w, index),
      options: _vm.intersectionOptions,
    }),expression:"{\n      active: !imagesSeen.includes(index),\n      callback: (w) => onImageWaypoint(w, index),\n      options: intersectionOptions,\n    }"}],key:item._key,staticClass:"slice--gallery__item",style:({
      '--grid-column-mobile': item.columnMobile,
      '--grid-row-mobile': item.rowMobile,
      '--grid-column': item.column,
      '--grid-row': item.row,
    })},[(item.render === 'Video')?_c('div',{staticClass:"slice--gallery__video",class:`${item.videoFolder.toLowerCase().replace(/ /g, '-')}`,staticStyle:{"position":"relative"},style:(`--padding-top: ${item.ratio}%; --padding-top-mobile: ${item.ratioMobile}%;`)},[_c('video-bunny',{attrs:{"src":`https://iframe.mediadelivery.net/embed/${
          _vm.BUNNY_STREAM_FOLDERS[item.videoFolder]
        }/${
          item.videoId
        }?responsive=true&autoplay=true&loop=true&muted=true&preload=true`}})],1):(item.render === 'Edito')?_c('div',{staticClass:"slice--gallery__edito",class:`slice--gallery__edito--${item.editoColor}`},[_c('portable-text',{attrs:{"blocks":item.edito}})],1):_c('image-with-products',{attrs:{"image-desktop":{
        image: item.image,
        widths: item.widths,
        sizes: item.sizes,
      },"image-mobile":{
        image: item.imageMobile,
        widths: item.widthsMobile,
        sizes: item.sizesMobile,
      }}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }